import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';
import Logger from '@/services/Logger.js';

class Users {
	// Retrieves a user by user ID
	// params: userId (string), callback (functiom)
	async getUser(userId) {
		return firebase
			.database()
			.ref(
				'/' +
					process.env.VUE_APP_FIREBASE_USERS_COLLECTION +
					'/' +
					userId
			)
			.once('value');
	}

	// Retrieves a list of all users
	getUsers() {
		return firebase
			.database()
			.ref(process.env.VUE_APP_FIREBASE_USERS_COLLECTION + '/')
			.orderByChild('email');
	}

	createUser(newUser, callback) {
		var userData = {};
		userData[
			process.env.VUE_APP_FIREBASE_USERS_COLLECTION + '/' + newUser.id
		] = newUser;
		return firebase
			.database()
			.ref()
			.update(userData, callback);
	}

	updateUserVaccineSubmitted(userId, status, callback) {
		var updates = {};
		updates[
			process.env.VUE_APP_FIREBASE_USERS_COLLECTION +
				'/' +
				userId +
				'/vaccineSubmitted'
		] = status;
		return firebase
			.database()
			.ref()
			.update(updates, callback);
	}

	makeAdmin(userEmail) {
		const addAdminRole = firebase.functions().httpsCallable('addAdminRole');
		addAdminRole({ email: userEmail }).then(
			result => {
				this.updateUser(result.userId, { admin: true });
			},
			error => {
				Logger.LogError('User Set Admin Failure', error);
			}
		);
	}
}

// Define as singleton
const instance = new Users();
Object.freeze(instance);

export default instance;
